import styled from 'styled-components'
import { COLORS } from 'containers/constants'

export const Legal = styled.small`
  color: #9E9E9E;
  padding-bottom: 10px;

  a {
      color: #9E9E9E;
  }
`
export const Button = styled.button`
  height: 40px;
  background-color: #323232;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  color: ${props => props.disabled ? 'darkgray' : '#fff'};
  font-weight: 600;
  font-size: 14px;
  border-width: 0;
  border-radius: 5px;
  margin-top: 20px;

  &:hover {
    cursor: ${props => props.disabled ? 'default' : 'pointer'};
  }
`
export const InlineLink = styled.span`
  font-size: 12px;
  text-decoration: none;
  color: ${COLORS.linkBlue};
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
`

export const GeekSquadLogo = styled.img`
  width: auto;
  height: 45px;
  display: block;
  padding: 15px 0;
`



// WEBPACK FOOTER //
// ./src/utils/sharedStyles.js